<template>
  <el-popover v-bind="$attrs" v-on="$listeners" trigger="hover" popper-class="phone-share" :width="150">
    <template slot="reference"></template>
    <slot slot="reference"></slot>
    <div>
      <canvas ref="qrCode"></canvas>
      <div class="share-name">手机浏览器扫一扫 快速便捷访问</div>
    </div>
  </el-popover>
</template>
<script>
import QRCode from 'qrcode';
export default {
  name: 'PhoneSharePopover',
  mounted() {
    this.createQrcode();
  },
  methods: {
    /**
     * 生成二维码
     */
    createQrcode() {
      QRCode.toCanvas(this.$refs.qrCode, location.href, { width: 80, margin: 0 });
    },
  },
};
</script>
<style lang="scss" scoped>
.share-name {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-top: 10px;
}
</style>
<style lang="scss">
.phone-share {
  box-sizing: border-box;
  text-align: center;
  padding-top: 25px;
  padding-bottom: 20px;
}
</style>
